import { loadable } from '../routing/loadable'

export const Home = loadable(() =>
  import(/* webpackChunkName: "home" */ './content/home/home'),
)
export const How = loadable(() =>
  import(/* webpackChunkName: "how" */ './content/how'),
)
export const About = loadable(() =>
  import(/* webpackChunkName: "about" */ './content/about'),
)
export const Service = loadable(() =>
  import(/* webpackChunkName: "service" */ './content/service'),
)
export const Conditions = loadable(() =>
  import(/* webpackChunkName: "conditions" */ './content/conditions'),
)
export const Privacy = loadable(() =>
  import(/* webpackChunkName: "privacy" */ './content/privacy'),
)
export const Trips = loadable(() =>
  import(/* webpackChunkName: "trips" */ './content/trips'),
)
export const GiftcardCampaign = loadable(() =>
  import(/* webpackChunkName: "bonbon" */ './content/giftcardCampaign'),
)
export const EndedGiftcardCampaign = loadable(() =>
  import(/* webpackChunkName: "bonbon" */ './content/endedGiftcardCampaign'),
)
export const SpontaneityConfirmation = loadable(() =>
  import(
    /*webpackChunkName: "spontaneity_confirm" */ './content/spontaneityConfirmation'
  ),
)
export const GiftcardCodeCampaign = loadable(() =>
  import(/* webpackChunkName: "ziengs" */ './content/giftcardCodeCampaign'),
)
export const Giftcard = loadable(() =>
  import(/* webpackChunkName: "giftcard" */ './giftcard/main'),
)
export const GiftcardGift = loadable(() =>
  import(/* webpackChunkName: "giftcardgift" */ './giftcard/gift'),
)
export const GiftcardTopUp = loadable(() =>
  import(/* webpackChunkName: "giftcardtopup" */ './giftcard/TopUp/TopUp'),
)
export const Follower = loadable(() =>
  import(/* webpackChunkName: "follower" */ './follower/main'),
)
export const Pin = loadable(() =>
  import(/* webpackChunkName: "pin" */ './pin/main'),
)
export const TripInfo = loadable(() =>
  import(/* webpackChunkName: "trip_info" */ './trip_info/main'),
)
export const Login = loadable(() =>
  import(/* webpackChunkName: "member_login" */ './member/login'),
)
export const Logout = loadable(() =>
  import(/* webpackChunkName: "member_logout" */ './member/logout'),
)
export const Member = loadable(() =>
  import(/* webpackChunkName: "member" */ './member/member'),
)
export const MemberInfo = loadable(() =>
  import(/* webpackChunkName: "member_info" */ './member/info'),
)
export const MemberSettings = loadable(() =>
  import(/* webpackChunkName: "member_settings" */ './member/settings'),
)
export const MemberWallet = loadable(() =>
  import(/* webpackChunkName: "member_wallet" */ './member/wallet'),
)
export const Survey = loadable(() =>
  import(/* webpackChunkName: "survey" */ './member/survey'),
)
export const DiscountCode = loadable(() =>
  import(/* webpackChunkName: "discount_code"*/ './discount/DiscountCode'),
)
export const SrprsInTheWild = loadable(() =>
  import(
    /* webpackChunkName: "srprs_in_the_wild"*/ './discount/SrprsInTheWild'
  ),
)
export const Register = loadable(() =>
  import(/* webpackChunkName: "member_login" */ './member/Register'),
)

// funnel
export const Customise = loadable(() =>
  import(/* webpackChunkName: "destination" */ './funnel/customise/fly'),
)
export const MulitCustomise = loadable(() =>
  import(
    /* webpackChunkName: "multiCustomise" */ './funnel/customise/multi_fly'
  ),
)
export const DriveCustomise = loadable(() =>
  import(/* webpackChunkName: "driveCustomise" */ './funnel/customise/drive'),
)
export const MultiDrive = loadable(() =>
  import(
    /* webpackChunkName: "multiDriveCustomise" */ './funnel/customise/multi_drive'
  ),
)

export const Extras = loadable(() =>
  import(/* webpackChunkName: "trip_options" */ './funnel/extras/main'),
)
export const Details = loadable(() =>
  import(/* webpackChunkName: "step4"*/ './funnel/details/main'),
)
export const Confirm = loadable(() =>
  import(/* webpackChunkName: "confirm" */ './funnel/confirm'),
)
export const Payment = loadable(() =>
  import(/* webpackChunkName: "payment" */ './payment/main'),
)
export const MolliePayment = loadable(() =>
  import(/* webpackChunkName: "molliepayment" */ './payment/mollie-main'),
)
export const Confirmed = loadable(() =>
  import(/* webpackChunkName: "step6" */ './funnel/confirmed'),
)
export const CustomPaymentThanks = loadable(() =>
  import(
    /* webpackChunkName: "custom_payment_thanks" */ './payment/CustomPaymentThanks'
  ),
)

export const MollieBookingComplete = loadable(() =>
  import(
    /* webpackChunkName: "booking_mollie_complete" */ './payment/MollieBookingComplete'
  ),
)

export const MollieGiftcardComplete = loadable(() =>
  import(
    /* webpackChunkName: "giftcard_mollie_complete" */ './payment/MollieGiftcardComplete'
  ),
)

// solo
export const Solo = loadable(() =>
  import(/* webpackChunkName: "solo" */ './funnel/solo-together'),
)
export const SoloCustomise = loadable(() =>
  import(
    /* webpackChunkName: "solo_customise" */ './funnel/solo-together/customise'
  ),
)

// totm
export const Totm = loadable(() =>
  import(/* webpackChunkName: "totm" */ './totm/surfNBeach'),
)
export const TotmCustomise = loadable(() =>
  import(/* webpackChunkName: "totm_customise"*/ './totm/surfNBeach/customise'),
)

// marketing pages
export const Ezy = loadable(() =>
  import(/* webpackChunkName: "solo" */ './funnel/ezy'),
)

export const Tube = loadable(() =>
  import(/* webpackChunkName: "tube" */ './funnel/tube'),
)

// landing page
export const LandingPage = loadable(() =>
  import(/* webpackChunkName: "loading" */ './content/landingPage'),
)
export const EntryPage = loadable(() =>
  import(/* webpackChunkName: "entry" */ './entries/entryPage'),
)

export const AdminLogin = loadable(() =>
  import(/* webpackChunkName: "admin_login" */ './admin/login'),
)
export const AdminPage = loadable(() =>
  import(/* webpackChunkName: "admin" */ './admin/admin'),
)
export const Reload = loadable(() =>
  import(/* webpackChunkName: "admin_login" */ './Reload'),
)

// around the world
export const AroundTheWorldConditions = loadable(() =>
  import(
    /* webpackChunkName: "around_the_world_conditions" */ './around_the_world/conditions'
  ),
)
export const AroundTheWorldLanding = loadable(() =>
  import(
    /* webpackChunkName: "around_the_world_landing" */ './around_the_world/landing'
  ),
)
export const AroundTheWorldPersonal = loadable(() =>
  import(
    /* webpackChunkName: "around_the_world_personal" */ './around_the_world/personal'
  ),
)
export const WillyWonka = loadable(() =>
  import(/* webpackChunkName: "willyWonka" */ './willyWonka/willyWonka'),
)
export const MGMShare = loadable(() =>
  import(/* webpackChunkName: "mgmShare" */ './member_get_member/share'),
)
export const MGMReferral = loadable(() =>
  import(/* webpackChunkName: "mgmReferral" */ './member_get_member/referral'),
)

export const ExtraInformation = loadable(() =>
  import(/* webpackChunkName: "extra-info" */ './member/ExtraInformation'),
)

export const HotelConfirmation = loadable(() =>
  import(/* webpackChunkName: "ziengs" */ './hotel-confirmation'),
)
